<mat-toolbar>
	<button mat-icon-button type="button" (click)="closeMenu()" i18n-aria-label aria-label="Close">
		<mat-icon class="app-24">close</mat-icon>
	</button>
	<div class="spacer"></div>
	<button mat-icon-button type="button" (click)="appService.toggleDarkTheme()" i18n-aria-label aria-label="Toggle dark mode" i18n-matTooltip [matTooltip]="appService.resolvedTheme() === 'app-dark-theme' ? 'Light mode' : 'Dark mode'">
		<mat-icon>{{ appService.resolvedTheme() === 'app-dark-theme' ? 'light_mode' : 'dark_mode' }}</mat-icon>
	</button>
	<button mat-icon-button type="button" [matMenuTriggerFor]="langMenu" i18n-matTooltip matTooltip="Switch language" i18n-aria-label aria-label="Switch language">
		<img [src]="currentLocale === 'es' ? 'images/icon-spanish-flag.png' : 'images/icon-english-flag.png'" [alt]="currentLocale" class="flag-icon">
	</button>
	<mat-menu #langMenu="matMenu">
		<button mat-menu-item type="button" (click)="switchTo('es')" [class.active-locale]="currentLocale === 'es'">
			<div class="language-menu-item">
				<img src="images/icon-spanish-flag.png" alt="ES" class="flag-icon">
				<span class="flag-text">ES</span>
			</div>
		</button>
		<button mat-menu-item type="button" (click)="switchTo('en')" [class.active-locale]="currentLocale === 'en'">
			<div class="language-menu-item">
				<img src="images/icon-english-flag.png" alt="EN" class="flag-icon">
				<span class="flag-text">EN</span>
			</div>
		</button>
	</mat-menu>
</mat-toolbar>
<div>
	<mat-nav-list>
		<a mat-list-item [routerLink]="['/']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="closeMenu()" class="app-elevation0 app-14" i18n>
			Inicio
		</a>
		<a mat-list-item [routerLink]="['/medicina-biorreguladora']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="closeMenu()" class="app-elevation0 app-14" i18n>
			Medicina Biorreguladora
		</a>
		<a mat-list-item [routerLink]="['/sueroterapia-autosanguis']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="closeMenu()" class="app-elevation0 app-14" i18n>
			Sueroterapia y Autosanguis
		</a>
		<a mat-list-item [routerLink]="['/contact']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="closeMenu()" class="app-elevation0 app-14" i18n>
			Contacto
		</a>
	</mat-nav-list>
	<div class="social" dir="rtl">
		<a href="https://wa.me/{{environment.contact.ibague.phone.replace('+','')}}" target="_blank" class="social-item">
			<mat-icon i18n-aria-label aria-label="whatsapp" [svgIcon]="'app-whatsapp'" class="app-elevation2 border-round"></mat-icon>
			<span class="app-12" i18n>Ibagué</span>
		</a>
		<a href="https://wa.me/{{environment.contact.bogota.phone.replace('+','')}}" target="_blank" class="social-item">
			<mat-icon i18n-aria-label aria-label="whatsapp" [svgIcon]="'app-whatsapp'" class="app-elevation2 border-round"></mat-icon>
			<span class="app-12" i18n>Bogotá</span>
		</a>
		<a [href]="environment.contact.instagram" target="_blank" class="social-item">
			<mat-icon i18n-aria-label aria-label="instagram" [svgIcon]="'app-instagram'" class="app-30 app-elevation2 border-round"></mat-icon>
		</a>
	</div>
</div>
